import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const InspectFooter = ({ children }) => (
  <div styleName="inspect-footer">{children}</div>
);

InspectFooter.propTypes = {
  children: PropTypes.node,
};

InspectFooter.defaultProps = {
  children: null,
};

export default InspectFooter;
